/**
 * Native HTML date input wrapped with PrimeReact styling, exposing an onChange prop
 * that receives `{ value }` matching other HiVolution form inputs.
 *
 * @component
 * @param {Object} props
 * @param {Boolean} [props.required] - Whether the input is required.
 * @param {Boolean} [props.disabled] - Whether the input is disabled.
 * @param {String} [props.value] - Current date value (ISO date string).
 * @param {String} [props.min] - Minimum selectable date (defaults to "1970-01-01").
 * @param {String} [props.max] - Maximum selectable date.
 * @param {Function} props.onChange - Called with `{ value }` when the date changes.
 * @returns {React.JSX.Element}
 */
export default function DateInput(props) {
  /**
   * Forwards the native input's change event to `props.onChange` as `{ value }`.
   *
   * @param {Event} e - Native change event from the input.
   * @returns {void}
   */
  const onChange = e => {
    props.onChange({ value: e.target.value })
  }

  return (
    <input
      required={props.required}
      disabled={props.disabled}
      className="p-inputtext p-component"
      type="date"
      value={props.value}
      min={props.min ? props.min : '1970-01-01'}
      max={props.max}
      onChange={onChange}
      onFocus={e => e.target.showPicker()}
    />
  )
}

DateInput.displayName = 'DateInput'
